import { Plus, X } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export default function CommissionPicker({ agents, value, onChange, testid = "commission" }) {
  const add = () => onChange([...value, { agent_code: "", agent_name: "", amount: 0 }]);
  const update = (i, patch) => {
    const next = value.map((c, idx) => (idx === i ? { ...c, ...patch } : c));
    onChange(next);
  };
  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-2" data-testid={`${testid}-picker`}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">Komisi Agen (opsional, bisa lebih dari 1)</span>
        <Button type="button" size="sm" variant="outline" onClick={add} data-testid={`${testid}-btn-add-agent`}>
          <Plus className="w-3.5 h-3.5 mr-1" /> Tambah Agen
        </Button>
      </div>
      {value.map((c, i) => (
        <div key={i} className="flex gap-2 items-center" data-testid={`${testid}-row-${i}`}>
          <Select
            value={c.agent_code}
            onValueChange={(code) => {
              const a = agents.find((x) => x.code === code);
              update(i, { agent_code: code, agent_name: a?.name || "" });
            }}
          >
            <SelectTrigger className="flex-1" data-testid={`${testid}-select-agent-${i}`}>
              <SelectValue placeholder="Pilih agen" />
            </SelectTrigger>
            <SelectContent>
              {agents.map((a) => (
                <SelectItem key={a.code} value={a.code}>{a.code} — {a.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Input type="number" min="0" className="w-32" placeholder="Rp" value={c.amount || ""}
            onChange={(e) => update(i, { amount: Number(e.target.value) })}
            data-testid={`${testid}-input-amount-${i}`} />
          <Button type="button" size="icon" variant="ghost" className="text-rose-400" onClick={() => remove(i)} data-testid={`${testid}-btn-remove-${i}`}>
            <X className="w-4 h-4" />
          </Button>
        </div>
      ))}
      {value.length > 0 && (
        <div className="text-xs text-muted-foreground font-mono" data-testid={`${testid}-total`}>
          Total komisi: Rp {value.reduce((s, c) => s + (Number(c.amount) || 0), 0).toLocaleString("id-ID")}
        </div>
      )}
    </div>
  );
}
